import { render, staticRenderFns } from "./StartWorkSection.vue?vue&type=template&id=13ee834f&scoped=true&lang=pug&"
import script from "./StartWorkSection.vue?vue&type=script&lang=js&"
export * from "./StartWorkSection.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkSection.vue?vue&type=style&index=0&id=13ee834f&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee834f",
  null
  
)

export default component.exports